import { css } from '@emotion/css';
import { HEADER_HEIGHT } from 'components/Header/constants';

export const SECTION_HEADING_HEIGHT: number = 6.5; // By design (in rem)

export const headingStyle = (top: number) => css`
  top: ${top}rem;
  height: ${SECTION_HEADING_HEIGHT + HEADER_HEIGHT}rem;
`;
